import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

const NoAccess = function() {
    return (
        <div className='NoAccess'>
            <div className='Error404'>
                <h1 className='fw-bolder'><i class="fa-solid fa-triangle-exclamation"></i> ERROR: 403</h1>
                <p className='regular'>
                    Üzr istəyirik, bu səhifəyə<br />
                    ÇIXIŞINIZ YOXDUR
                </p>
                <Link to="/">
                    <Button type="primary" size="large" danger><i class="fa-solid fa-arrow-left"></i> Əsas səhifə</Button>
                </Link>
            </div>

            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
    )
}

export default NoAccess;